import CollectionBlock from "../CollectionBlock/CollectionBlock"

const CollectionBlocks = ( { data } ) => {
    // console.log('data in collection blocks', data)
    return (
        <div className="collection-blocks-outer">
            <div className="collection-blocks-inner">
                <div className="collection-blocks">
                    {data ? data.collections.map((c) => {
                        // console.log('c in collection blocks', c)
                        return (<CollectionBlock key={c.id} collection={c} />)
                    }) : <div>Loading...</div>}
                </div>

            </div>
        </div>
    )
}

export default CollectionBlocks
